import { render, staticRenderFns } from "./SingleImageUpload.vue?vue&type=template&id=bafd66e2&scoped=true&"
import script from "./SingleImageUpload.vue?vue&type=script&lang=js&"
export * from "./SingleImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./SingleImageUpload.vue?vue&type=style&index=0&id=bafd66e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafd66e2",
  null
  
)

export default component.exports